import React from 'react'

export type TdProps = React.HTMLAttributes<HTMLTableDataCellElement>

const Td = React.forwardRef<HTMLTableDataCellElement, TdProps>(
  ({ children, className }, ref) => {
    const Element = !React.isValidElement(children) ? (
      <span className="text-sm text-gray-900">{children}</span>
    ) : (
      children
    )
    return (
      <td
        ref={ref}
        className={`px-6 py-4 text-sm text-center whitespace-nowrap ${
          className || ''
        } overflow-ellipsis overflow-hidden`}
      >
        {Element}
      </td>
    )
  }
)

export default Td
